import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { User } from 'firebase/auth';
import { AuthService } from 'src/app/features/services/auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class ToolsService {

  constructor(private afs: AngularFirestore,private auth:AuthService) { }
  isNullOrUndefined(value : any ):boolean{
    return value === null || value === undefined;
  }
  isNull(value: string):boolean{
    return  value === null
  }
  isUndefined(value: any):boolean{
    return  value === undefined 
  }
  async userConnected(){
    const user = await this.auth.isLoggedIn()
    if (user) {
      return this.auth.getUser()
    } else {
      return false
    //  return   this.router.navigate(['login'])
 
   }
  }
}
